<div [ngClass]="classes">
  <span class="badge__text">
    {{ label }}
  </span>
</div>
